import { Avatar, Checkbox, Flex } from 'antd';
import Text from 'components/Text';
import styled from 'styled-components';
import { IStaffUI } from 'types/staff';
import { toneAvatar, toneFill, useStaffGroupTone } from 'widgets/Staff/useStaffGroupTone';
import iconDown from './ReviewTab/icons/down.svg';

/** Mot lich trong nhom: nguoi lam va co phai khach request dung nguoi do khong. */
export type IStaffAssignItem = {
  uuid: string;
  staff: IStaffUI;
  requestStaff: boolean;
};

type Props = {
  value?: IStaffAssignItem;
  servicesText: string;
  time: string;
  customer: string;
  onChange?: (value: IStaffAssignItem) => void;
  onChangeStaff: (onChange: (staff: IStaffUI) => void) => void;
};

const StaffAssignItem = ({ value, time, servicesText, customer, onChange, onChangeStaff }: Props) => {
  const toneOf = useStaffGroupTone();
  const tone = toneOf(value?.staff?.id);
  const handleOnChangeStaff = () => {
    if (!value || !onChange) return;
    // Giu nguyen requestStaff khi doi staff: chon lai nguoi lam khong dong nghia voi doi y
    // ve viec khach co request hay khong.
    onChangeStaff(staff => onChange({ ...value, staff }));
  };
  const handleToggleRequestStaff = (checked: boolean) => {
    if (!value || !onChange) return;
    onChange({ ...value, requestStaff: checked });
  };
  return <StaffAssignItemStyled>
    <div className='time-appointment'>{time}</div>
    <div className='customer-appointment'>{customer}</div>
    <div className='services-appointment'>Ser: {servicesText}</div>
    <Flex gap={'8px'} align='center' style={{ width: '100%', marginTop: '24px' }} justify='space-between'>
      <div className='customer-appointment' style={{ flex: 1 }} >Staff:</div>
      <button type='button' className={`btn-choose-staff ${tone ? 'grouped' : ''}`} style={toneFill(tone)} onClick={handleOnChangeStaff}>
        <Flex gap={'8px'} align='center' style={{ flex: 1 }} justify='flex-start'>
          <Avatar size={'default'} src={value?.staff?.avatar} style={toneAvatar(tone)}>{value?.staff?.name?.[0] || 'A'}</Avatar>
          <Text className="staff-name">{value?.staff?.name || 'Anyone'}</Text>
        </Flex>
        <img src={iconDown} alt="iconDown" className='icon-down' />
      </button>
    </Flex>
    <Checkbox
      className='checkbox-request-staff'
      checked={!!value?.requestStaff}
      onChange={(e) => handleToggleRequestStaff(e.target.checked)}
    >
      Request Staff
    </Checkbox>
  </StaffAssignItemStyled>;
};

export default StaffAssignItem;

const StaffAssignItemStyled = styled.div`
border-radius: 5px;
overflow: hidden;

display: flex;
flex-direction: column;
justify-content: space-between;
padding: 4px 8px;
flex: 1;
background: #fff;
border: 0.5px solid #0D446C;
box-shadow: inset 3px 0px 0px 0px #0D446C;

.time-appointment {
  color: #1D2129;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.customer-appointment {
  color: #1D2129;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.services-appointment {
  color: #1D2129;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.checkbox-request-staff {
  margin-top: 8px;
  align-self: flex-start;
  .ant-checkbox + span {
    color: #1D2129;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
.btn-choose-staff {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  border: 1px solid #CECECE;
  background: #FFF;
  padding: 2px 4px;
  max-width: 200px;
  &:hover {
    opacity: 0.6;
  }
  .icon-down {
    height: 28px;
    width: 28px;
  }

  .staff-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #1D2129;
    text-overflow: ellipsis;
  }
  &.grouped .staff-name { color: inherit; }
}
`;
